import React, { useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Blog from "../../../../../component/blog";
import ErrorLabel from "../../../../../component/error_label";
import Newsletter from "../../../../../component/newsletter";
import OurApp from "../../../../../component/our_app";
import RecommendedPolicy from "../../../../../component/recommended_policy";
import { useDropzone } from 'react-dropzone';
import $ from 'jquery'
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from 'moment'
import { actionDropdown, resetDropdownDataResponse } from "../../../../../common/store";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../../../../common/app_constant";
import toast, { LoaderIcon } from "react-hot-toast";
import { actionIntimateClaim } from "../store";
import UploadDocuments from "../upload_doc";
import ClaimDetail from "../claim_detail_popup";
import Loader from "../../../../../component/page_loader";


const IntimateClaim = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();

    const { dropdownData } = useSelector((state) => ({
        ...state.commonStore
    }))

    const { intimateClaim } = useSelector((state) => ({
        ...state.claimStore
    }))


    const {
        register,
        formState: { errors },
        handleSubmit, getValues, setValue, watch, control } =
        useForm({
            defaultValues:
            {
                is_active: false,
                policy_no: '',
                nameOfInsured: '',
                policy_type_name: '',
                claim_type: 'Re-Imbursement'
            },
        });

    const [allDropdownArr, setAllDropdownArr] = useState(null)
    const [isUploadDoc, setIsUploadDoc] = useState(false)
    const [intimateclaimObj, setIntimateClaimObj] = useState(null)
    const [isDisplayClaimDetail, setIsDisplayClaimDetail] = useState(false)
    const [claimDetailObj, setClaimDetailObj] = useState(null)
    const [isLoader, setLoader] = useState(false)

    useEffect(() => {
        if (location?.state.data) {
            setValue('policy_no', location?.state?.data.policy_no)
            setValue('nameOfInsured', location?.state?.data.company_name)
            setValue('policy_type_name', location?.state?.data.policy_type_name)
            setValue('rm_name', location?.state?.data.rm_name)
            setValue('department_name', location?.state?.data.department_name)
            // setValue('claim_type', location?.state?.data?.claims[0]?.claim_type)
        }
    }, [location])

    useEffect(() => {
        if (getValues('is_active') === false) {
            setValue('is_active', true)
            dispatch(actionDropdown())
        }
    }, [])


    useEffect(() => {
        if (intimateClaim !== null) {
            if (intimateClaim.result === true) {
                setLoader(false)
                setIntimateClaimObj(intimateClaim.response)
                setIsUploadDoc(true)
                // navigate("claim");
                // toast.success(intimateClaim.message, {
                //     duration: TOAST_DURATION,
                //     position: TOAST_POSITION,
                //     style: {
                //         color: TOAST_SUCCESS_COLOR
                //     }
                // })
            } else {
                switch (intimateClaim.status_code) {
                    case 400:
                        toast.error(intimateClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                    default:
                }
            }
        }
    }, [intimateClaim])


    useEffect(() => {
        if (dropdownData !== null) {
            dispatch(resetDropdownDataResponse())
            if (dropdownData.result === true) {
                // setValue('allDropdownArr', dropdownData.data)
                setAllDropdownArr(dropdownData.data)

            } else {
                switch (dropdownData.status_code) {

                    default:
                }
            }
        }
    }, [dropdownData])

    const generateLossType = () => {
        var menu = [];
        if (allDropdownArr != null && allDropdownArr.loss_type.length > 0) {
            allDropdownArr.loss_type.forEach(function (child, labelIndex) {
                menu.push(
                    <option key={labelIndex} value={child}>
                        {child}
                    </option>
                );
            });
        }
        return menu;
    };

    const onSubmit = async (data) => {
        setClaimDetailObj(data)
        setIsDisplayClaimDetail(true)
    }
    return (
        <>
            {
                isLoader === true ?
                    <Loader />
                    : <></>
            }

            <div className="row py-5">
                <div className="col-12">
                    <nav
                        className="--bs-breadcrumb-divider"
                        aria-label="breadcrumb"
                    >
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a onClick={() => {
                                    navigate('/dashboard')
                                }}>Dashboard</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Intimate Claim
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    <div class="mt-4 row justify-content-between tab-menu">
                        <div class="col-12 col-md-4">
                            <a href="#" class="btn btn-light btn-sm mx-2 fw-bold my-auto">Intimate Claim</a>
                        </div>
                        {/* <div class="col-12 col-md-8 text-end">
                                    <button href="#" class="btn btn-light btn-sm active  " aria-current="page"> Show Policy Detail </button>
                                    <button href="#" class="btn btn-warning btn-sm "> View All Policies </button>
                                </div> */}
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <form
                                        noValidate
                                        autoComplete="off"
                                        onSubmit={handleSubmit(
                                            onSubmit
                                        )}>                                                <div class="row">
                                            <div class="col-12">
                                                <label for="policy_no" class="form-label">Policy Number</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="policy_no"
                                                    {...register(
                                                        "policy_no",
                                                        {
                                                            required: "This is required.",
                                                            minLength: {
                                                                value: 6,
                                                                message: " Policy No cannot be less than 6-chars."
                                                            },
                                                            maxLength: {
                                                                value: 30,
                                                                message: " Policy No cannot be greater than 30-chars."
                                                            },
                                                        }
                                                    )}
                                                />
                                                {errors.policy_no && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .policy_no
                                                                ?.message
                                                        }
                                                    />
                                                )}</div>
                                            <div class="col-md-6 mt-3">
                                                <label for="nameOfInsured" class="form-label">Name Of Insured</label>
                                                <input type="text" class="form-control"
                                                    id="nameOfInsured"
                                                    {...register(
                                                        "nameOfInsured"
                                                    )}
                                                    disabled />
                                            </div>
                                            <div class="col-md-6 mt-3">
                                                <label for="policy_type_name" class="form-label">Type Of Policy</label>
                                                <input type="text" class="form-control" id="policy_type_name"
                                                    {...register(
                                                        "policy_type_name"
                                                    )}
                                                    disabled />
                                            </div>
                                            <div class="col-md-6 mt-3">
                                                <div class="form-group has-search">
                                                    <label for="querytype" class="form-label">Date of Loss<span
                                                        class="text-danger">*</span></label>
                                                    <span class="fa fa-calendar form-control-feedback"></span>
                                                    <Controller
                                                        name='date_of_loss'
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Flatpickr
                                                                {...field}
                                                                onChange={(value) => {
                                                                    var date = new Date(value).toISOString()
                                                                    setValue('date_of_loss', moment(date).format('DD-MM-YYYY'))
                                                                }}
                                                                id='disabled-picker'
                                                                className="form-control"
                                                                options={{
                                                                    dateFormat: 'd-m-Y',
                                                                    // minDate: 'today',
                                                                    maxDate: 'today',
                                                                    enableTime: false
                                                                }}
                                                            />
                                                        )}
                                                        rules={{
                                                            required: "This is required."
                                                        }}
                                                    />
                                                    {errors.date_of_loss && (
                                                        <ErrorLabel
                                                            message={
                                                                errors
                                                                    .date_of_loss
                                                                    ?.message
                                                            }
                                                        />
                                                    )}
                                                </div>

                                            </div>
                                            <div class="col-md-6 mt-3">
                                                <label for="claimType" class="form-label">Claim Type</label>
                                                <input
                                                    id="claim_type"
                                                    className="form-control form-select"
                                                    {...register(
                                                        "claim_type"
                                                    )}
                                                    disabled
                                                />
                                                {errors.claim_type && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .claim_type
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-md-6 mt-3">
                                                <label for="lossType" class="form-label">Type Of Loss<span
                                                    class="text-danger">*</span></label>
                                                <select
                                                    id="nature_of_claim"
                                                    className="form-control form-select"
                                                    {...register(
                                                        "nature_of_claim",
                                                        {
                                                            required: "This is required."
                                                        }
                                                    )}
                                                >
                                                    <option value="">Type Of Loss</option>
                                                    {generateLossType()}
                                                </select>
                                                {errors.nature_of_claim && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .nature_of_claim
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <div class="col-md-6 mt-3">
                                                <label for="amount" class="form-label">Estimate Loss Amount<span
                                                    class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="amount"
                                                    {...register(
                                                        "amount",
                                                        {
                                                            required: "This is required."
                                                        }
                                                    )}
                                                />
                                                {errors.amount && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .amount
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-12 col-md-6 mt-3">
                                                <label for="loss_details" class="form-label">Claim Description <span class="text-danger">
                                                    *</span></label>
                                                <textarea class="form-control" id="loss_details" rows="3"
                                                    {...register(
                                                        "loss_details",
                                                        {
                                                            required: "This is required."
                                                        }
                                                    )}
                                                ></textarea>
                                                {errors.loss_details && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .loss_details
                                                                ?.message
                                                        }
                                                    />
                                                )}</div>
                                            <div class="col-12 col-md-6 mt-3">
                                                <label for="loss_location" class="form-label">Loss Location<span class="text-danger">
                                                    *</span></label>
                                                <textarea class="form-control" id="lossLocation" rows="3"
                                                    {...register(
                                                        "loss_location",
                                                        {
                                                            required: "This is required."
                                                        }
                                                    )}
                                                ></textarea>
                                                {errors.loss_location && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .loss_location
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-md-6 mt-3">
                                                <label for="contact_person_name" class="form-label">Loss Site Contact Person Name<span
                                                    class="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="contact_person_name"
                                                    {...register(
                                                        "contact_person_name",
                                                        {
                                                            required: "This is required."
                                                        }
                                                    )}
                                                />
                                                {errors.contact_person_name && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .contact_person_name
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-md-6 mt-3">
                                                <label for="contact_person_mobile_number" class="form-label">Loss Site Contact Person Mobile
                                                    Number<span class="text-danger">*</span></label>
                                                <input type="number"
                                                    class="form-control"
                                                    min={0}
                                                    {...register(
                                                        "contact_person_mobile_number",
                                                        {
                                                            required: "This is required.",
                                                            maxLength: {
                                                                value: 10,
                                                                message: "Mobile No. must be of 10-digits."
                                                            },
                                                            minLength: {
                                                                value: 10,
                                                                message: "Mobile No. must be of 10-digits."
                                                            },
                                                            pattern: {
                                                                value: /^[6789]\d{9}$/,
                                                                message: ' Mobile Number should start with 6, 7, 8 or 9'

                                                            }
                                                        })}
                                                />
                                                {errors.contact_person_mobile_number && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .contact_person_mobile_number
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-md-4 mt-3">
                                                <label for="alternate_contact_person_name" class="form-label">Alternate Contact Person Name</label>
                                                <input type="text" class="form-control" id="alternate_contact_person_name"
                                                    {...register(
                                                        "alternate_contact_person_name"
                                                    )}
                                                />
                                                {errors.alternate_contact_person_name && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .alternate_contact_person_name
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-md-4 mt-3">
                                                <label for="alternate_contact_person_mobile_number" class="form-label">Alternate Contact Person Number </label>
                                                <input type="number"
                                                    class="form-control"
                                                    min={0}
                                                    {...register(
                                                        "alternate_contact_person_mobile_number",
                                                        {
                                                            maxLength: {
                                                                value: 10,
                                                                message: "Mobile No. must be of 10-digits."
                                                            },
                                                            minLength: {
                                                                value: 10,
                                                                message: "Mobile No. must be of 10-digits."
                                                            },
                                                            pattern: {
                                                                value: /^[6789]\d{9}$/,
                                                                message: ' Mobile Number should start with 6, 7, 8 or 9'

                                                            }
                                                        })}
                                                />
                                                {errors.alternate_contact_person_mobile_number && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .alternate_contact_person_mobile_number
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-md-4 mt-3">
                                                <label for="alternate_contact_person_email" class="form-label">Alternate Contact Person Email</label>
                                                <input type="text" class="form-control" id="alternate_contact_person_email"

                                                    {...register(
                                                        "alternate_contact_person_email",
                                                        {
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                message: "Enter valid Email Id.",
                                                            },
                                                        }
                                                    )}
                                                />
                                                {errors.alternate_contact_person_email && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .alternate_contact_person_email
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div class="col-12 mt-3">
                                                <button type="submit" class="btn btn-primary">Submit</button>
                                                <button type="btn" class="btn btn-secondary" style={{ marginLeft: 8, }} onClick={() => {
                                                    navigate(-1)
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <RecommendedPolicy />
                    <Newsletter />
                    <Blog />
                    <OurApp />
                </div>
            </div>

            <UploadDocuments
                isUploadDoc={isUploadDoc}
                intimateclaimObj={intimateclaimObj}
                isUploadDocClose={() => {
                    setIsUploadDoc(false)
                    navigate("/claim");
                    window.location.reload()
                }}
            />
            <ClaimDetail
                isDisplayClaimDetail={isDisplayClaimDetail}
                claimDetailObj={claimDetailObj}
                isClaimDetailClose={({ data }) => {
                    if (data === true) {
                        setLoader(true)
                        setIsDisplayClaimDetail(false)
                        dispatch(actionIntimateClaim({
                            control_no: location?.state?.data.control_no,
                            policy_no: location?.state?.data.policy_no,
                            date_of_loss: moment(claimDetailObj.date_of_loss, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                            claim_type: claimDetailObj.claim_type,
                            nature_of_claim: claimDetailObj.nature_of_claim,
                            amount: claimDetailObj.amount,
                            loss_details: claimDetailObj.loss_details,
                            loss_location: claimDetailObj.loss_location,
                            contact_person_name: claimDetailObj.contact_person_name,
                            contact_person_mobile_number: claimDetailObj.contact_person_mobile_number,
                            alternate_contact_person_name: claimDetailObj.alternate_contact_person_name,
                            alternate_contact_person_mobile_number: claimDetailObj.alternate_contact_person_mobile_number,
                            alternate_contact_person_email: claimDetailObj.alternate_contact_person_email
                        }))
                    } else {
                        setIsDisplayClaimDetail(false)
                    }
                }}
            />
        </>


    )

}

export default IntimateClaim;